import { RestError } from "../../services/rest-service/RestService";
import { useMutation, useQueryClient } from "react-query";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";
import { IConfiguration } from "../../services/data-file-import-data-service/Models";
import DataFileImportDataService from "../../services/data-file-import-data-service/DataFileImportDataService";

export type MutationContextType = {
    previous: IConfiguration | undefined;
};

export type UseSaveDataFileImportConfigurationParameters = {
    groupID: number,
} & BaseUseMutationParameters<IConfiguration, IConfiguration>;

export function useSaveDataFileImportConfiguration({
    groupID,
    onError,
    onSuccess
}: UseSaveDataFileImportConfigurationParameters) {
    const queryClient = useQueryClient();

    return useMutation<IConfiguration, RestError, IConfiguration, MutationContextType>(
        (item) => {
            return DataFileImportDataService.saveConfiguration(groupID, item);
        },
        {
            onMutate: async (item: IConfiguration) => {

                await queryClient.cancelQueries(keys.all);

                queryClient.invalidateQueries({
                    queryKey: [keys.all],
                    active: true,
                    inactive: true
                    //type: 'all'
                });

                queryClient.refetchQueries({
                    queryKey: [keys.configurations, keys.configuration],
                    active: true,
                    inactive: true
                });

                return {
                    previous: item
                };
            },
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}
